import type { LiveItem } from '@module/apis/client-side/live/type';

interface parameter {
  list: LiveItem[];
  currentScreenSize: 'xl' | 'lg' | 'md';
  listLength: 12 | 15;
}

function getMainListAdjustSize({ list, currentScreenSize, listLength }: parameter) {
  if (list.length === 0) return;

  let itemsPerRow = 4;
  if (currentScreenSize === 'xl') itemsPerRow = 6;
  else if (currentScreenSize === 'lg') itemsPerRow = 5;

  let trimmedList = list.slice(0, listLength);
  const maxIterations = 2;
  let iteration = 0;
  if (list.length < itemsPerRow) {
    // 예) 4배수 (col 4 row 1)으로 출력을 할 때 4개 미만의 아이템이 있을 경우 NewBJ 출력을 하지 않는다.
    return [];
  }
  while (
    // trimmedList.length > itemsPerRow &&
    trimmedList.length % itemsPerRow !== 0 &&
    iteration < maxIterations
  ) {
    const sliceEnd = listLength - itemsPerRow * (iteration + 1);
    trimmedList = trimmedList.slice(0, sliceEnd);
    iteration++;
  }

  return trimmedList;
}

export default getMainListAdjustSize;
